import { BBB_GET_JOIN_URL } from '../actions';
import { getJoinUrl } from '../api';

const fetchJoinUrlStarted = (payload) => ({
  type: BBB_GET_JOIN_URL,
  status: 'started',
  payload,
});

const fetchJoinUrlSuccess = (payload) => ({
  type: BBB_GET_JOIN_URL,
  status: 'success',
  payload,
});

const fetchJoinUrlError = (payload) => ({
  type: BBB_GET_JOIN_URL,
  status: 'error',
  payload,
});

const fetchJoinUrl =
  ({ id, context }) =>
  async (dispatch) => {
    const payload = { id, context };
    dispatch(fetchJoinUrlStarted(payload));
    try {
      const url = await getJoinUrl({ id, context });
      dispatch(fetchJoinUrlSuccess({ ...payload, url }));
      return url;
    } catch (error) {
      dispatch(fetchJoinUrlError({ ...payload, error }));
      return null;
    }
  };

export default fetchJoinUrl;
